import { render, staticRenderFns } from "./CommissionsManager.vue?vue&type=template&id=3b35fc1c&scoped=true"
import script from "./CommissionsManager.vue?vue&type=script&lang=js"
export * from "./CommissionsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35fc1c",
  null
  
)

export default component.exports